module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/adminnoticias/adminnoticias.component.scss
// module id = ./src/app/adminnoticias/adminnoticias.component.scss
// module chunks = main